import { Image, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { stylesPdf } from '.';
import { dateformat } from '../../helpers';
import { Config } from '../../widgets/template/Config';
import { getFileUrl } from '../archivos/ArchivosAction';

const styles = {
  section: {
    ...stylesPdf.row,
    justifyContent: 'space-between',
  },
  text: {
    ...stylesPdf.title,
    fontSize: 12,
  },
  nameTime: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  nameApp: {
    ...stylesPdf.title,
    fontSize: 5,
  },
};

const HeaderPdf = ({ entidad }) => {
  return (
    <View
      style={{
        width: '100%',
        flexDirection: 'column',
      }}
    >
      <View style={styles.nameTime}>
        <Text style={styles.nameApp}>{dateformat(null, { full: true })}</Text>
        <Text style={styles.nameApp}>{Config.onEDU}</Text>
      </View>
      <View style={styles.section}>
        <View
          style={{
            width: '7%',
          }}
        >
          {entidad.imgLogo && (
            <Image style={stylesPdf.logo} src={getFileUrl(entidad.imgLogo)} />
          )}
        </View>
        <View>
          <Text style={styles.text}>{entidad.nombre}</Text>
        </View>
        <View
          style={{
            width: '7%',
          }}
        ></View>
      </View>
    </View>
  );
};

export default HeaderPdf;
